import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { getShowInfo, getVenueInfo, fetchShowAndVenueInfo } from './actions';
import type { ShowInfoByIdResponse, VenueInfoResponse } from '../models/show.interface';

// Общий интерфейс для выбранной даты
export interface SelectedDateInfo {
  date: string;
  time: string;
  eventId: number;
}

interface DateSelectionState {
  selected: SelectedDateInfo | null;
  showInfo: ShowInfoByIdResponse | null;
  venueInfo: VenueInfoResponse | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: DateSelectionState = {
  selected: null,
  showInfo: null,
  venueInfo: null,
  isLoading: false,
  error: null,
};

const prepareShowInfoState = (
  state: DateSelectionState,
  { payload }: PayloadAction<ShowInfoByIdResponse | null>
) => {
  state.showInfo = payload;
};

export const dateSelectionSlice = createSlice({
  name: 'dateSelection',
  initialState,
  reducers: {
    setSelectedDate: (state, action: PayloadAction<SelectedDateInfo>) => {
      state.selected = action.payload;
    },
    resetShowInfo: prepareShowInfoState,
  },
  extraReducers: builder => {
    builder.addCase(getShowInfo.pending, state => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(getShowInfo.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.showInfo = payload;
    });
    builder.addCase(getShowInfo.rejected, (state, { payload }) => {
      state.isLoading = false;
      state.error = payload as string;
      state.showInfo = null;
    });

    builder.addCase(getVenueInfo.pending, state => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(getVenueInfo.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.venueInfo = payload;
    });
    builder.addCase(getVenueInfo.rejected, (state, { payload }) => {
      state.isLoading = false;
      state.error = payload as string;
      state.venueInfo = null;
    });

    builder.addCase(fetchShowAndVenueInfo.pending, state => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(fetchShowAndVenueInfo.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.showInfo = payload;
    });
    builder.addCase(fetchShowAndVenueInfo.rejected, (state, { payload }) => {
      state.isLoading = false;
      state.error = payload as string;
    });
  },
});

export const { setSelectedDate, resetShowInfo } = dateSelectionSlice.actions;
export default dateSelectionSlice.reducer;
